import { z } from "zod";

import { MetadataSchema } from "api/schemas/common";
import { TreatmentActivityLogCategories } from "api/schemas/TreatmentActivityLog";

const GetPendingTreatmentActivityLogsArgsSchema = z.object({
  health_care_organization_id: z.number(),
  params: z
    .object({
      limit: z.number().optional(),
      page: z.number().optional(),
    })
    .optional(),
});
export type GetPendingTreatmentActivityLogsArgs = z.infer<typeof GetPendingTreatmentActivityLogsArgsSchema>;

const PendingActivityLogSchema = z.object({
  category: TreatmentActivityLogCategories,
  completed_at: z.string().nullable(),
  course_week: z.number(),
  duration: z.number(),
  duration_unit: z.string(),
  id: z.number(),
  patient_id: z.number(),
  patient_name: z.string(),
  start_time: z.string(),
  status: z.string(),
  therapist_id: z.number(),
  therapist_name: z.string(),
});

export const GetPendingTreatmentActivityLogsResponseSchema = z.object({
  items: z.array(PendingActivityLogSchema),
  metadata: MetadataSchema,
});
